module.exports = __webpack_public_path__ + "media/images/emblems/Mervelier-Blazono-ef420e937494648f099f26f060999e03.png";